module.exports = __webpack_public_path__ + "static/media/jar-logo-large.0938eed9.png";